var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Section',{staticClass:"center-content",style:([
    { height: _vm.height },
    _vm.backgroundImage ? { backgroundImage: 'url(' + _vm.backgroundImage + ')' } : ''
  ]),attrs:{"wrap":"","pad":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }